import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import PageHero from "@/components/PageHero";
import CtaBand from "@/components/CtaBand";
import Carousel from "@/components/Carousel";
import { REAL_ESTATE_OFFERINGS, REAL_ESTATE_GALLERY } from "@/data/content";

const RealEstate = () => (
    <div data-testid="real-estate-page">
        <Seo
            title="Real Estate Advisory & Leasing in South Delhi | Kavraj Spaces"
            description="Residential and commercial property advisory across Delhi with deep South Delhi expertise — HNI & UHNI mandates, pre-rented investments, farmhouses, leasing and institutional sourcing."
        />

        <PageHero
            eyebrow="Capability 01 — Real Estate"
            title="Property advisory, from search to signature."
            intro="We assist clients across India, with particular expertise in premium residential properties across Delhi NCR, alongside commercial property advisory, investment opportunities, leasing and institutional sourcing — all handled with discretion."
            testid="real-estate-hero"
        />

        <section className="bg-cream" data-testid="real-estate-offerings">
            <div className="mx-auto max-w-7xl px-6 py-20 sm:px-12 lg:px-20 lg:py-32">
                <div className="grid grid-cols-1 gap-12 lg:grid-cols-3 lg:gap-16">
                    <Reveal className="lg:col-span-1">
                        <h2 className="font-serif text-3xl tracking-tight text-ink sm:text-4xl">
                            What we advise on
                        </h2>
                        <p className="mt-5 text-base leading-relaxed text-stone2">
                            Every engagement begins with listening: the purpose of the property, the
                            horizon, and the standard expected. From there, we source, evaluate and
                            negotiate — quietly and thoroughly.
                        </p>
                        <div className="mt-10">
                            <Carousel images={REAL_ESTATE_GALLERY} testid="real-estate-carousel" />
                        </div>
                    </Reveal>
                    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:col-span-2">
                        {REAL_ESTATE_OFFERINGS.map((offering, i) => (
                            <Reveal key={offering.title} delay={(i % 2) * 100}>
                                <div
                                    className="h-full border border-bronze/15 bg-cream-muted p-7 transition-colors duration-300 hover:border-bronze/40"
                                    data-testid={`offering-card-${i}`}
                                >
                                    <h3 className="font-serif text-xl leading-snug text-ink">
                                        {offering.title}
                                    </h3>
                                    <p className="mt-3 text-sm leading-relaxed text-stone2">
                                        {offering.text}
                                    </p>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                </div>
            </div>
        </section>

        <section className="border-y border-bronze/15 bg-cream-muted" data-testid="real-estate-south-delhi">
            <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-6 py-20 sm:px-12 lg:grid-cols-2 lg:gap-20 lg:px-20 lg:py-28">
                <Reveal>
                    <h2 className="font-serif text-3xl tracking-tight text-ink sm:text-4xl">
                        Deep roots where the city&rsquo;s finest addresses are.
                    </h2>
                </Reveal>
                <Reveal delay={120}>
                    <p className="text-base leading-relaxed text-stone2">
                        Our advisory practice is built on first-hand knowledge of Delhi&rsquo;s
                        finest colonies, builder floors, farmhouses and commercial micro-markets —
                        the kind of understanding that only comes from decades of working these
                        streets.
                    </p>
                    <p className="mt-5 text-base leading-relaxed text-stone2">
                        The same practice supports leasing requirements for embassies and consulates,
                        and sources institutional properties such as guest houses — work that demands
                        patience, protocol and precision.
                    </p>
                </Reveal>
            </div>
        </section>

        <CtaBand
            title="Looking for the right property in Delhi?"
            text="Tell us the purpose and the pin code you have in mind. We will take it from there."
        />
    </div>
);

export default RealEstate;
